import urlCatalog from '@angi/url-catalog';
import React from 'react';
import { Track } from 'angieslist-app-platform';
import './HelpFooter.scss';

const HelpFooter = () => (
  <div className="businesslist-help-container">
    <div className="h1 help-title"> Need help? <br className="help-title-break" />We&#39;re here for you </div>
    <div className="help-description-container">
      <div className="help-description"> Call us at
        <Track>
          <a href={urlCatalog.global.customerCarePhone()} id="phone"> {urlCatalog.global.customerCarePhoneText()}. </a>
        </Track>
        Monday-Friday 8AM-8PM ET and Saturday 9AM-3PM ET.
      </div>
    </div>
  </div>
);

export default HelpFooter;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/HelpFooter.js